module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJpJREFUOBFjYKAlkOv87yrd+d8Znx0s+CT//2PwZPgPhAwMe3Gpw2vAPwaGfwyMuLRCxJnwSxOWHXgDwD4Eh/RfBi+gf0EBhgwsoZzjyIJAZzMxMjFsf1TOuBsciMxAgf+MDIzAQEM3AFkfnP0PEjNA5QSAdPv/HhDGp2zgA5HGLvjPAAxsBryW4E3KDMwM24DxjNcAfAFMlBwAYEYgBlwue5gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icons/ic_btn_add.png
// module id = ZTxy
// module chunks = 83